export default __webpack_public_path__ + "static/media/Emissary.93be214a.png";